export enum ProductTagEnum {
  PROMOTIONAL = 'promotional'
}

export enum MarketProductTagEnum {
  GradientBackground = 'gradient-background',
  LastTime = 'last-time',
  Promotional = 'promotional',
  BorderWarning = 'border-warning',
  ImmediateRedemption = 'immediate-redemption'
}

type ProductWithTags = {
  tags: string[] | null
}

export const isProductPromotional = (product: ProductWithTags) => !!product.tags?.includes(ProductTagEnum.PROMOTIONAL)
